import React, { ReactElement, useEffect } from 'react';
import { UploadedFile } from 'slovlex-idsk-react-components';
import { useClient, useClientStatusContext } from '../../../context/ClientStatusContext';
import prilohaAktuEuDownloadClient from '../../../client/external/prilohaAktuEuDownloadClient';
import mapDate from '../../../function/mapDate';
import PrilohaAktEu from '../../../model/PrilohaAktEu';
import { useSecurityContext } from '../../../context/SecurityContext';

interface Props {
  priloha: PrilohaAktEu;
}

const PrilohaAktuEuComponent = ({ priloha }: Props): ReactElement => {
  const {
    wrapClient: downloadPrilohaAktEuClient,
    status: downloadPrilohaAktEuStatus,
  } = useClient(prilohaAktuEuDownloadClient);
  const { handleStatus } = useClientStatusContext();
  const { accessToken, organizationId } = useSecurityContext();

  useEffect(() => {
    if (downloadPrilohaAktEuStatus.responseCode === 404) {
      handleStatus({
        loading: false,
        finished: true,
        responseCode: 404,
        failed: true,
        generalErrors: [{ message: 'Pri sťahovaní dokumentu nastal neočakávaný problém (neexistujúci súbor).' }],
        fieldErrors: [],
      });
    } else if (downloadPrilohaAktEuStatus.responseCode === 401
      || downloadPrilohaAktEuStatus.responseCode === 403) {
      handleStatus({
        loading: false,
        finished: true,
        responseCode: 403,
        failed: true,
        generalErrors: [{
          message: 'Uvedená príloha obsahuje citlivé informácie a nie je prístupná verejnosti. '
              + 'Stiahnuť túto prílohu môže iba prihlásený používateľ s potrebným oprávnením.',
        }],
        fieldErrors: [],
      });
    }
  }, [downloadPrilohaAktEuStatus, handleStatus]);

  const handleClick = async (): Promise<void> => {
    const headers = {
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
    };
    try {
      const { data } = await downloadPrilohaAktEuClient(priloha.uuid, { headers });

      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${priloha.fileName}`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      // eslint-disable-next-line no-empty
    } catch (ex) {
    }
  };

  return (
    <UploadedFile
      file={new File([''], `${priloha.fileName}`)}
      fileSize={priloha.fileSize}
      onDownload={handleClick}
      inputFilename={priloha.name}
      jazyk={priloha?.jazyk?.nazov}
      datumPublikacie={mapDate(priloha?.datumPublikacie)}
      typDokumentu={priloha?.typDokumentuAktEu?.nazov}
    />
  );
};

export default PrilohaAktuEuComponent;
